export const CapaOwnerChangeSchema: any = {
  previousOwnerId: {},
  currentOwnerId: {},
  caraId: "",
  updatedBy: {},
  reason: "",
  organizationId: "",
};
